"use strict";
// P5 W4 — managed software/firmware release contracts (FS §4).
//
// Three layers:
//   1. SoftwareBundle{Kind,Class,State} enums — mirror the Prisma model
//      (apps/server/prisma/schema.prisma enum SoftwareBundleKind/Class/State).
//   2. PlayerUpgradeAvailable — the rich, signed payload the Class A PWA
//      uses to apply an upgrade (sha256 + Ed25519 manifest signature).
//      Class B's existing apk-update endpoint returns a simpler
//      ApkUpdateResponse (unchanged from P3 W3 T10).
//   3. PlayerUpgradeResponse — wraps the available upgrade (or null when
//      no applicable bundle) plus a server-anchored next_poll_after hint.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerUpgradeResponse = exports.PlayerUpgradeAvailable = exports.SoftwareBundleState = exports.SoftwareBundleClass = exports.SoftwareBundleKind = void 0;
const zod_1 = require("zod");
exports.SoftwareBundleKind = zod_1.z.enum(['pwa_app', 'android_apk', 'led_firmware']);
exports.SoftwareBundleClass = zod_1.z.enum(['A', 'B', 'C']);
exports.SoftwareBundleState = zod_1.z.enum([
    'draft',
    'pending_review',
    'recommended',
    'approved',
    'revoked',
    'expired',
]);
/** FS §4.3 pull-path response shape. */
exports.PlayerUpgradeAvailable = zod_1.z.object({
    bundle_id: zod_1.z.string().uuid(),
    version: zod_1.z.string(),
    bytes_url: zod_1.z.string(), // relative; player resolves against origin
    byte_size: zod_1.z.number().int().positive(),
    bytes_sha256: zod_1.z.string().regex(/^[0-9a-f]{64}$/),
    manifest_canonical_json: zod_1.z.string().min(1),
    signature_b64: zod_1.z.string().min(1),
    signing_key_id: zod_1.z.string().uuid(),
});
exports.PlayerUpgradeResponse = zod_1.z.object({
    upgrade: exports.PlayerUpgradeAvailable.nullable(),
    next_poll_after: zod_1.z.string().datetime(),
});
//# sourceMappingURL=software.schema.js.map